import React, { useMemo } from "react";
import { PleaseWaitSpinner } from "../../../../jsxctl/utilctl";
import { PriceGroupModel } from "../../../tsrestapi/models";
import './pricegroupbuttons.scss';

import { ButtonInfo, ButtonsList } from "../../molecules";

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;

interface PriceGroupButtonsProps {
    priceGroups: PriceGroupModel[],
    processing: boolean,
    onClick: (priceGroupId: number) => void;
}

export function PriceGroupButtons({priceGroups, processing, onClick}: PriceGroupButtonsProps) {
    const buttonsInfo : ButtonInfo[] = useMemo(() => priceGroups.map((priceGroup: PriceGroupModel) => {
        const buttonInside = <div className="btn-inside">
            <div className="hidden-xs glyphicon glyphicon-plus btn-icon"></div> 
            <div>{tr("Ajouter à mon panier d'achat au tarif {name}", { name: priceGroup.internetNameFr})}</div>
        </div>;

        return {
            class: "btn btn-primary text-uppercase",
            children: buttonInside,
            disabled: processing,
            onClick: () => onClick(priceGroup.id)
        };
    }),[priceGroups, processing, onClick]);

    return <div>
        {
            processing ? <div>
                <div className="text-center">
                    <PleaseWaitSpinner size="md" />
                </div>
            </div> 
            : <div className="PriceGroupButtons">
                <ButtonsList buttonInfos={buttonsInfo}/>
            </div>
        }
    </div>;
}